import Index from './components/Index'

export default [
    {
        path: 'products/:search?',
        component: Index,
        name: 'labelinsight-products.index',
        meta: {
            auth: 'label_insight_products.view',
            pageTitle: 'Products',
        },
    },
]
